import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const SymptomTrendChart = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-muted-foreground text-sm">
        No symptom trend data available
      </div>
    );
  }

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg shadow-therapeutic-lg p-3">
          <p className="text-sm font-medium text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <p key={index} className="text-xs text-muted-foreground">
              <span style={{ color: entry?.color }}>{entry?.name}:</span> {entry?.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
        <defs>
          <linearGradient id="colorMild" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="hsl(var(--success))" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="hsl(var(--success))" stopOpacity={0}/>
          </linearGradient>
          <linearGradient id="colorModerate" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="hsl(var(--warning))" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="hsl(var(--warning))" stopOpacity={0}/>
          </linearGradient>
          <linearGradient id="colorSevere" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="hsl(var(--error))" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="hsl(var(--error))" stopOpacity={0}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
        <XAxis 
          dataKey="date" 
          stroke="hsl(var(--muted-foreground))"
          style={{ fontSize: '12px' }}
        />
        <YAxis 
          stroke="hsl(var(--muted-foreground))"
          style={{ fontSize: '12px' }}
        />
        <Tooltip content={<CustomTooltip />} />
        <Area 
          type="monotone" 
          dataKey="mild" 
          name="Mild"
          stackId="1"
          stroke="hsl(var(--success))" 
          fill="url(#colorMild)" 
        />
        <Area 
          type="monotone" 
          dataKey="moderate" 
          name="Moderate"
          stackId="1"
          stroke="hsl(var(--warning))" 
          fill="url(#colorModerate)" 
        />
        <Area 
          type="monotone" 
          dataKey="severe" 
          name="Severe"
          stackId="1"
          stroke="hsl(var(--error))" 
          fill="url(#colorSevere)" 
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default SymptomTrendChart;